export default [
    {
        path: 'impressao',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-impressao' */
            '@/views/exame-imagem/impressao/Index'
        ),
        redirect: 'impressao/index',
        children: [
            {
                name: 'exame-imagem-impressao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-impressao' */
                    '@/views/exame-imagem/impressao/List'
                ),
            },
        ]
    }
]